import { directionalProperty, rem } from 'polished';
import styled, { css } from 'styled-components';

import { colors, fontSizes, fontWeights, spacing } from '../../theme';

const draftCardTitleStyles = css(({ theme }) => ({
  backgroundColor: theme.core.color.forest[700],
  color: theme.core.color.dollar[400],
}));

export const CardTitleRoot = styled.div<{ $isDraft?: boolean }>(
  ({ theme, $isDraft }) => {
    const variant = theme.components.ContainerLabel.regular;

    return css`
      box-sizing: border-box;
      display: flex;
      gap: ${spacing['4x']};
      align-items: center;
      height: fit-content;
      color: ${variant.fg};
      background-color: ${variant.bg};
      border-radius: ${variant.radius};

      ${directionalProperty(
        'padding',
        variant['vertical-padding'],
        variant['horizontal-padding'],
      )}

      ${$isDraft ? draftCardTitleStyles : ''}
    `;
  },
);

export const CardTitleLabel = styled.div`
  font-size: ${fontSizes.xs};
  font-weight: ${fontWeights.medium};
  line-height: ${rem(16)};
  color: inherit;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const CardTitleDraftLabel = styled.div`
  font-size: ${fontSizes.xxs};
  font-weight: ${fontWeights.regular};
  line-height: ${rem(12)};
  color: ${colors.pigeon};
  text-align: center;
  letter-spacing: 0.02em;
`;
